// extracted by mini-css-extract-plugin
export default {"wrapper":"DeliverInfo_wrapper__D2lMW","container":"DeliverInfo_container__JJX+R","pCenter":"DeliverInfo_pCenter__AxAxm"};